import { render, staticRenderFns } from "./EmbedLink.vue?vue&type=template&id=23dbae93&"
import script from "./EmbedLink.vue?vue&type=script&lang=ts&"
export * from "./EmbedLink.vue?vue&type=script&lang=ts&"
import style0 from "./EmbedLink.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports